<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:45:32
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 15:51:50
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\components\xm-tenant-modal.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import {
  Modal as AModal,
  Spin as ASpin
} from 'ant-design-vue'

import XmTenantForm from './xm-tenant-form.vue'

import { useXmTenantModalStore } from '../stores/xm-tenant-modal'

const XmTenantModalStore = useXmTenantModalStore()

const {
  modalProps,
  loading
} = storeToRefs(XmTenantModalStore)

const {
  onCancel,
  onOk
} = XmTenantModalStore
</script>

<template>
  <AModal v-bind="modalProps" @cancel="onCancel" @ok="onOk">
    <ASpin :spinning="loading">
      <XmTenantForm />
    </ASpin>
  </AModal>
</template>
